// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loadingSpinnerWrapper--Gwdbe {
  height: 300px;
}

.container--z1qyW {
  font-family: var(--base-font);
  font-weight: 500;
}

[dir] .container--z1qyW {
  padding: 0;
}

@media (min-width: 768px) {
  [dir] .container--z1qyW {
    padding: 0 60px;
  }
}

.doc_grid--CgFvK {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 20px;
  grid-auto-flow: row;
}

[dir] .doc_grid--CgFvK {
  margin: 20px auto !important;
}

.doc_grid_expand--tFbMB {
  grid-column: span 1;
}

.doc_grid_100--yZnjo {
  grid-column: span 1;
}

.doc_grid_l--vBGEI {
  grid-column: span 1;
}

.doc_grid_r--QGfOV {
  grid-column: span 1;
}

@media (min-width: 768px) {
  .doc_grid--CgFvK {
    grid-template-columns: 1fr 1fr;
    grid-auto-flow: column;
  }
  .doc_grid_100--yZnjo {
    grid-column: 1 / span 2;
  }
  .doc_grid_l--vBGEI {
    grid-column: 1 / span 1;
  }

  .doc_grid_r--QGfOV {
    grid-column: 2 / span 1;
  }
  .doc_grid_expand--tFbMB {
    grid-column: 1 / span 2;
  }
}

.chartTitle--ezJc6 {
  font-size: 16px;
}

[dir] .chartTitle--ezJc6 {
  text-align: center;
  margin-top: 15px;
  margin-bottom: 15px !important;
}

.chartTitleWrapper--YWn8v {
  align-items: center;
  display: flex;
  gap: 8px;
  justify-content: center;
}

.titleInfoIcon--rlgXj {
  display: inline-flex;
  align-items: center;
}

[dir] .titleInfoIcon--rlgXj {
  cursor: help;
}

.titleInfoImg--NtLKF {
  width: 17px;
  height: 17px;
}

[dir] .headerPanelWrapper--weGfy {
  margin-bottom: 25px;
}

.columnTitle--hT7gO {
  font-weight: 700;
}

[dir] .accordionWrapper--QmwaF {
  margin-top: 25px;
  border: 1px solid rgba(184, 184, 184, 0.3);

  margin-bottom: 25px !important;
}

.advancedHeader--_ZGTx {
  line-height: 20px;
  order: var(--order);
}

[dir] .advancedHeader--_ZGTx {
  padding: 20px 10px 0px 10px;
  text-align: center;
}

.spacer--VJTA2 {
  height: 25px;
}

[dir=ltr] .expandIcon--RpU2V {
  margin-left: 10px;
}

[dir=rtl] .expandIcon--RpU2V {
  margin-right: 10px;
}

.subTablesWrapper--gi3I0 {
  height: 0px;
  overflow: hidden;
  order: var(--order);
}

.active--CQDKv {
  height: auto;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/DriversOfChangeChart/styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAElB;;AAJA;EAGE,UAAU;AACZ;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,cAAc;EACd,mBAAmB;AAErB;;AANA;EAKE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,8BAA8B;IAC9B,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA;EAEE,eAAe;AAGjB;;AALA;EACE,kBAAkB;EAElB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AAErB;;AAJA;EAGE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,0CAA0C;;EAE1C,8BAA8B;AAChC;;AAEA;EAEE,iBAAiB;EAEjB,mBAAmB;AACrB;;AALA;EACE,2BAA2B;EAE3B,kBAAkB;AAEpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAFA;EACE,kBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd","sourcesContent":[".loadingSpinnerWrapper {\n  height: 300px;\n}\n\n.container {\n  font-family: var(--base-font);\n  font-weight: 500;\n  padding: 0;\n}\n\n@media (min-width: 768px) {\n  .container {\n    padding: 0 60px;\n  }\n}\n\n.doc_grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-gap: 20px;\n  grid-auto-flow: row;\n  margin: 20px auto !important;\n}\n\n.doc_grid_expand {\n  grid-column: span 1;\n}\n\n.doc_grid_100 {\n  grid-column: span 1;\n}\n\n.doc_grid_l {\n  grid-column: span 1;\n}\n\n.doc_grid_r {\n  grid-column: span 1;\n}\n\n@media (min-width: 768px) {\n  .doc_grid {\n    grid-template-columns: 1fr 1fr;\n    grid-auto-flow: column;\n  }\n  .doc_grid_100 {\n    grid-column: 1 / span 2;\n  }\n  .doc_grid_l {\n    grid-column: 1 / span 1;\n  }\n\n  .doc_grid_r {\n    grid-column: 2 / span 1;\n  }\n  .doc_grid_expand {\n    grid-column: 1 / span 2;\n  }\n}\n\n.chartTitle {\n  text-align: center;\n  font-size: 16px;\n  margin-top: 15px;\n  margin-bottom: 15px !important;\n}\n\n.chartTitleWrapper {\n  align-items: center;\n  display: flex;\n  gap: 8px;\n  justify-content: center;\n}\n\n.titleInfoIcon {\n  display: inline-flex;\n  align-items: center;\n  cursor: help;\n}\n\n.titleInfoImg {\n  width: 17px;\n  height: 17px;\n}\n\n.headerPanelWrapper {\n  margin-bottom: 25px;\n}\n\n.columnTitle {\n  font-weight: 700;\n}\n\n.accordionWrapper {\n  margin-top: 25px;\n  border: 1px solid rgba(184, 184, 184, 0.3);\n\n  margin-bottom: 25px !important;\n}\n\n.advancedHeader {\n  padding: 20px 10px 0px 10px;\n  line-height: 20px;\n  text-align: center;\n  order: var(--order);\n}\n\n.spacer {\n  height: 25px;\n}\n\n.expandIcon {\n  margin-left: 10px;\n}\n\n.subTablesWrapper {\n  height: 0px;\n  overflow: hidden;\n  order: var(--order);\n}\n\n.active {\n  height: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loadingSpinnerWrapper": `loadingSpinnerWrapper--Gwdbe`,
	"container": `container--z1qyW`,
	"doc_grid": `doc_grid--CgFvK`,
	"doc_grid_expand": `doc_grid_expand--tFbMB`,
	"doc_grid_100": `doc_grid_100--yZnjo`,
	"doc_grid_l": `doc_grid_l--vBGEI`,
	"doc_grid_r": `doc_grid_r--QGfOV`,
	"chartTitle": `chartTitle--ezJc6`,
	"chartTitleWrapper": `chartTitleWrapper--YWn8v`,
	"titleInfoIcon": `titleInfoIcon--rlgXj`,
	"titleInfoImg": `titleInfoImg--NtLKF`,
	"headerPanelWrapper": `headerPanelWrapper--weGfy`,
	"columnTitle": `columnTitle--hT7gO`,
	"accordionWrapper": `accordionWrapper--QmwaF`,
	"advancedHeader": `advancedHeader--_ZGTx`,
	"spacer": `spacer--VJTA2`,
	"expandIcon": `expandIcon--RpU2V`,
	"subTablesWrapper": `subTablesWrapper--gi3I0`,
	"active": `active--CQDKv`
};
export default ___CSS_LOADER_EXPORT___;
